<template>
  <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M7 16l-4-4m0 0l4-4m-4 4h18"
  ></path>
</template>
